import { DEFAULT_PAGE_NUMBER } from 'utils/constants';

/**
 * Determines if the market should show loading state (dim/grey out).
 * Returns true for initial load and fresh loads (filter/shipping/metric changes),
 * but false for pagination so the UI stays responsive when loading more products.
 */
export const getLoadingMarket = (isFetching: boolean, pageNumber: number, sectionsCount: number): boolean => {
  const isPagination = pageNumber > DEFAULT_PAGE_NUMBER && sectionsCount > 0;
  return isFetching && !isPagination;
};
